import { Controller } from '@hotwired/stimulus';
import { CupertinoPane } from 'cupertino-pane';

const MOBILE_BREAKPOINT = 768;
const PANE_TOP_PADDING = 16;

export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(() => this.sync());
    this.observer.observe(this.element, { childList: true });
    this.sync();
  }

  disconnect() {
    this.observer.disconnect();
    this.destroyPane();
  }

  sync() {
    const box = this.element.querySelector('.x-alert-box');

    if (!box) {
      this.destroyPane();
      return;
    }
    if (this.paneBox && !this.element.contains(this.paneBox)) this.destroyPane();
    if (window.innerWidth >= MOBILE_BREAKPOINT) return;
    if (box === this.paneBox) return;

    this.destroyPane();
    this.presentPane(box);
  }

  presentPane(box) {
    const pane = new CupertinoPane(box, {
      parentElement: this.element,
      backdrop: false,
      buttonDestroy: false,
      showDraggable: true,
      bottomClose: true,
      fastSwipeClose: true,
      initialBreak: 'top',
      breaks: this.breaksConfig(box),
      events: {
        onDidDismiss: () => {
          if (this.pane !== pane) return;

          this.pane = null;
          this.paneBox = null;
          new window.ActionPopup().close();
        },
      },
    });

    this.pane = pane;
    this.paneBox = box;
    pane.present({ animate: true });
  }

  breaksConfig(box) {
    const height = Math.min(box.scrollHeight + PANE_TOP_PADDING, Math.round(window.innerHeight * 0.9));

    return {
      top: { enabled: true, height },
      middle: { enabled: false },
      bottom: { enabled: false },
    };
  }

  destroyPane() {
    const { pane, paneBox } = this;
    if (!pane) return;

    this.pane = null;
    this.paneBox = null;
    const stale = !this.element.contains(paneBox);

    pane.destroy({ animate: false });

    if (stale) paneBox.remove();
  }
}
